import { createContext, useMemo } from "react";
import { useEnsureContext } from "@madmedical/utils";
import { useLinkHandler } from "@madmedical/routing";
const RoutingContext = createContext(undefined);
export const RoutingProvider = RoutingContext.Provider;
export const useRouteNavigate = () => {
    const { navigate } = useEnsureContext(RoutingContext);
    return navigate;
};
export const useLinking = (route, params, search) => {
    const { generatePath, isActive } = useEnsureContext(RoutingContext);
    const path = generatePath(route, params, search);
    const handlePress = useLinkHandler(path);
    return useMemo(() => ({
        onPress: handlePress,
        accessibilityRole: "link",
        href: path,
        isActive: isActive(route, params),
    }), [handlePress, path, isActive, route, params]);
};
